import type { GridApi } from '@mui/x-data-grid-pro';
import * as React from 'react';

export const useAllowColumnReorderDropAnywhere = (apiRef: React.RefObject<GridApi>): void => {
  const isColumnDragActiveRef = React.useRef(false);

  React.useEffect(() => {
    const api = apiRef.current;
    if (!api) return undefined;
    const unsubscribeDragStart = api.subscribeEvent('columnHeaderDragStart', () => {
      isColumnDragActiveRef.current = true;
    });
    const unsubscribeDragEnd = api.subscribeEvent('columnHeaderDragEndNative', () => {
      isColumnDragActiveRef.current = false;
    });
    return () => {
      unsubscribeDragStart();
      unsubscribeDragEnd();
    };
  }, [apiRef]);

  React.useEffect(() => {
    const gridRoot = apiRef.current?.rootElementRef?.current;
    if (!gridRoot) return undefined;
    const acceptDragOverDuringColumnDrag = (event: DragEvent) => {
      if (isColumnDragActiveRef.current) {
        event.preventDefault();
      }
    };
    gridRoot.addEventListener('dragover', acceptDragOverDuringColumnDrag, true);
    return () => gridRoot.removeEventListener('dragover', acceptDragOverDuringColumnDrag, true);
  }, [apiRef]);
};
